import React, { useState } from "react";
import DeveloperPortalSidebar from "./sidebar/DeveloperPortalSidebar";
import DeveloperPortalHeader from "./header/DeveloperPortalHeader";
import SystemStatusFooter from "./footer/SystemStatus";

interface IProps {
  children: React.ReactNode;
}

const DeveloperPortalLayout: React.FC<IProps> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <div className="developer-portal-layout">
      {/* Mobile Toggle Button could be added here if needed */}
      <DeveloperPortalSidebar />

      <main className="portal-main">
        <DeveloperPortalHeader />
        
        <div className="portal-content">
          {children}
        </div>

        <SystemStatusFooter />
      </main>
    </div>
  );
};

export default DeveloperPortalLayout;
